import React from 'react';
import { Row } from '@zendeskgarden/react-grid';
import Icon from 'components/Icon/Icon';
import { variables } from 'theme/variables';
import {
  OverlayContainer,
  MainHeader,
  DescriptiveParagraph,
  ScopeGrid,
  ScopeGridBlock,
  ScopeListItem,
  PercentageDiv,
} from './InspectionScopesOverlay.styles';

const { color_green_400: colorGreen400, custom_blue: customBlue } = variables;

function InspectionScopesOverlay() {
  const iconStyle = {
    color: colorGreen400,
    top: 0,
    fontSize: '14px',
    paddingRight: '5px',
  };

  // TODO: P10-862 condense code into reusable list and icon components rather than the repetition.
  return (
    <OverlayContainer>
      <img
        style={{ display: 'block', maxWidth: '200px' }}
        src="/images/pipeFactsV2.svg"
        alt="horizontal pipefacts logo"
      />
      <MainHeader>Our Inspection Scopes and Criteria</MainHeader>
      <DescriptiveParagraph>
        PipeFacts™ is a proprietary inspection process that measures up to 220+
        data points through a combination of field assessments, formal
        inspections, and office technical review. We utilize API 5CRA as our
        baseline analysis criteria and have included other industry best
        practices to guide our comprehensive quality service, PipeFacts™. As a
        result of our quality data collection, we provide buyers with a
        comprehensive Executive Summary to equip you with all of the information
        needed to put this material into critical application.
      </DescriptiveParagraph>
      <ScopeGrid>
        <Row size={12} className="titleRow">
          <ScopeGridBlock className="colTitle" size={1} />
          <ScopeGridBlock className="colTitle right">
            Field Inspection
          </ScopeGridBlock>
          <ScopeGridBlock className="colTitle right">
            Receiving Inspection
          </ScopeGridBlock>
          <ScopeGridBlock className="colTitle" size={4}>
            Final Inspection
          </ScopeGridBlock>
        </Row>
        <Row size={12} className="dataRow">
          <ScopeGridBlock
            className="colTitle percentage_bubble bottom"
            size={1}
          >
            <PercentageDiv percentage={100}>
              <div className="percentage_div">{100}%</div>
            </PercentageDiv>
          </ScopeGridBlock>
          <ScopeGridBlock className="right bottom" />
          <ScopeGridBlock className="right bottom">
            <ul>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Visual Body Inspection (VBI){' '}
              </ScopeListItem>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Tally
              </ScopeListItem>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Traceability to MTRs
              </ScopeListItem>
            </ul>
          </ScopeGridBlock>
          <ScopeGridBlock className="bottom" size={4}>
            <ul style={{ columns: 2 }}>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Visual Body Inspection (VBI)
              </ScopeListItem>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Full MTR review
              </ScopeListItem>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Etching Confirmation
              </ScopeListItem>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Tally
              </ScopeListItem>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Drift
              </ScopeListItem>
            </ul>
          </ScopeGridBlock>
        </Row>
        <Row size={12} className="dataRow">
          <ScopeGridBlock className="percentage_bubble bottom" size={1}>
            <PercentageDiv percentage={10}>
              <div className="percentage_div">{10}%</div>
            </PercentageDiv>
          </ScopeGridBlock>
          <ScopeGridBlock className="right bottom">
            <ul>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Traceability to MTRs
              </ScopeListItem>
            </ul>
          </ScopeGridBlock>
          <ScopeGridBlock className="right bottom" />
          <ScopeGridBlock className="bottom" size={4} />
        </Row>
        <Row size={12} className="dataRow">
          <ScopeGridBlock className="percentage_bubble bottom" size={1}>
            <PercentageDiv percentage={5}>
              <div className="percentage_div">{5}%</div>
            </PercentageDiv>
          </ScopeGridBlock>
          <ScopeGridBlock className="right bottom">
            <ul>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Visual Body Inspection (VBI)
              </ScopeListItem>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Visual Thread Inspection (VTI)
              </ScopeListItem>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Tally
              </ScopeListItem>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Drift
              </ScopeListItem>
            </ul>
          </ScopeGridBlock>
          <ScopeGridBlock className="right bottom">
            <ul>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Visual Thread Inspection
              </ScopeListItem>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Drift
              </ScopeListItem>
            </ul>
          </ScopeGridBlock>
          <ScopeGridBlock className="bottom" size={4}>
            <ul>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Visual Thread Inspection (VTI)
              </ScopeListItem>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Dimensional Inspection (Pipe)
              </ScopeListItem>
              <ScopeListItem>
                <Icon icon="icon-checkmark" style={iconStyle} fontSize=".8em" />
                Dimensional Inpsection (Coupling)
              </ScopeListItem>
            </ul>
          </ScopeGridBlock>
        </Row>
        <Row size={12} className="dataRow">
          <ScopeGridBlock className="percentage_bubble bottom" size={1}>
            <PercentageDiv percentage={1}>
              <div className="percentage_div">{1}%</div>
            </PercentageDiv>
          </ScopeGridBlock>
          <ScopeGridBlock className="right bottom" />
          <ScopeGridBlock className="right bottom" />
          <ScopeGridBlock className="bottom" size={4}>
            <ul>
              <ScopeListItem>PMI</ScopeListItem>
            </ul>
          </ScopeGridBlock>
        </Row>
        <Row size={12} className="dataRow">
          <ScopeGridBlock className="percentage_bubble" size={1} />
          <ScopeGridBlock className="right" />
          <ScopeGridBlock className="right" />
          <ScopeGridBlock size={4}>
            <ul>
              <ScopeListItem>
                <Icon
                  fontAwesome
                  iconPrefix="fas"
                  color={customBlue}
                  style={{
                    alignSelf: 'start',
                    marginTop: '-12px',
                    marginRight: '5px',
                    padding: 0,
                  }}
                  icon="plus-circle"
                  fontSize="17px"
                />
                200+ data points at various scopes to ensure this asset is
                prepared for primary application!
              </ScopeListItem>
            </ul>
          </ScopeGridBlock>
        </Row>
      </ScopeGrid>
    </OverlayContainer>
  );
}

export default InspectionScopesOverlay;
